namespace Fable.Import

open Fable.Core
open Fable.Core.JsInterop
open Fable.Import.React
open Fable.Helpers.React

module ReactVirtualized =

    type CellRendererArg =
        { cellData: obj
          columnData: obj
          columnIndex: int
          dataKey: string
          isScrolling: bool
          rowData: obj
          rowIndex: int }

    let formatDate (date: System.DateTime) =
        let date' = date.ToLocalTime()
        sprintf "%02d.%02d.%04d" date'.Day date'.Month date'.Year 

    let dateCellRenderer {cellData = cellData} =
        if isNull cellData then "" else cellData :?> System.DateTime |> formatDate
    
    let inline reactCom<'T when 'T :> React.Component<obj,obj>> propList =
        let props = keyValueList CaseRules.LowerFirst propList
        com<'T, obj, obj>(props)

    type ColumnProps =
        | CellRenderer of (CellRendererArg -> string)
        | DataKey of string
        | DisableSort of bool
        | Label of string
        | Width of int

    [<Import("Column", "react-virtualized")>]
    type Column(props) =
        inherit Component<obj, obj>(props)

    let column propList = reactCom<Column> propList

    type RowIndex = { index: int }

    type RowEventData<'RowDataType> = { event: React.MouseEvent; index: int; rowData: 'RowDataType }

    type SortArg = { SortBy: string; SortDirection: string }

    type TableProps<'RowDataType> = 
        | HeaderHeight of int
        | Height of int
        | OnRowClick of (RowEventData<'RowDataType> -> unit)
        | RowClassName of (RowIndex -> string)
        | RowCount of int
        | RowGetter of (RowIndex -> obj)
        | RowHeight of int
        | Sort of (SortArg -> unit)
        | SortBy of string
        | SortDirection of string
        | Width of int

    [<Import("Table", "react-virtualized")>]
    type Table(props) =
        inherit Component<obj, obj>(props)

    let table propList = reactCom<Table> propList


// WEBPACK FOOTER //
// src/import/Fable.Import.ReactVirtualized.fs